const navItems = ["dla klienta", "dla pracownika", "dla pracodawcy", "faq"];
export default navItems;
